import { Box, IconButton, Stack, styled } from "@mui/material";

export const CarouselTrack = styled(Box)({
  display: "flex",
  gap: 16,
  overflowX: "auto",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  paddingBottom: 4,
  "&::-webkit-scrollbar": {
    display: "none",
  },
  msOverflowStyle: "none",
  scrollbarWidth: "none",
});

export const CarouselNavButton = styled(IconButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.common.white,
  width: 36,
  height: 36,
  "&:hover": {
    backgroundColor: theme.palette.grey[50],
  },
}));

export const CarouselSectionHeader = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
});

export const CarouselTitleRow = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
  gap: 8,
});
